<template>
    <section class="view fix-space__button" v-if="hasPermissions(['Assignment-Project-Template Read'])">

        <DetailComponent
            :breadcrumb="breadcrumb"
            :rest_api="rest_api"
            :parent_id="parent_id"
            :rest_api_note="rest_api_note"
            :title_page="title_page"
            :single_object="single_object"
            :array_options="array_options"
            :form_format="form_format"
            :notes="single_object.notes_entities"
            :back_href="'/assignment-projects'"
            :map="false"
        />

        <div class="row mb-0">
            <div class="col my-3">
                <hr/>
            </div>
            <div class="col-12 duties pt-0">

                <div class="row mb-0 justify-content-xl-between">
                    <div class="col-md-auto flex-xl-grow-1">
                        <!-- <div class="modal__buttons text-center text-md-left mt-0 mt-md-auto"/> -->
                        <div class="modal__buttons text-center text-md-left">
                            <span class="custom-control custom-checkbox">
                                <input :id="'hideCompletedTasks'" type="checkbox" class="custom-control-input" v-model="check_completed_task" />
                                <label :for="'hideCompletedTasks'" class="custom-control-label ml-2" v-html="'Hide completed tasks'"/>
                            </span>
                        </div>
                    </div>
                    <div class="col-md-auto flex-xl-grow-1">
                        <div class="modal__buttons text-center text-md-left mt-0 mt-md-auto"/>
                    </div>
                    <div class="col-md-auto flex-xl-grow-1">
                        <div class="modal__buttons text-center text-md-left text-lg-right">
                            <div v-if="hasPermissions(['Assignment-Project-Template Write'])"
                                class="btn-group modal__buttons__item w-auto px-3 mr-md-2"
                                style="margin-top:-2px;">
                                <button type="button"
                                    style="border-top-right-radius: 0px; border-bottom-right-radius: 0px; padding-right:15px;"
                                    v-html="'Export to'" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" />
                                <button type="button" class="dropdown-toggle dropdown-toggle-split ml-0" data-toggle="dropdown"
                                    aria-haspopup="true" aria-expanded="false"
                                    style="border-top-left-radius: 0px; border-bottom-left-radius: 0px; padding-right:0px;">
                                    <span class="sr-only">Toggle Dropdown</span>
                                </button>
                                <div class="dropdown-menu" :style="'font-size: 14px; padding:0; margin-top: 0px;'">
                                    <a class="dropdown-item" href="#" @click="confirmationReportModal('xlsx')" v-html="'xlsx'" type="button"/>
                                    <a class="dropdown-item" href="#" @click="confirmationReportModal('csv')" v-html="'csv'" type="button"/>
                                    <a class="dropdown-item" href="#" @click="confirmationReportModal('portrait')" v-html="'PDF portrait'" type="button"/>
                                    <a class="dropdown-item" href="#" @click="confirmationReportModal('landscape')" v-html="'PDF landscape'" type="button"/>
                                </div>
                            </div>
                            <button  v-if="hasPermissions(['Assignment-Project-Template Write'])" class="modal__buttons__item w-auto ml-0 mr-1 mr-md-0 px-3" :class="{'disabled button__disabled' : !selected}" :disabled="!selected" v-html="`Skip overdue tasks`" @click="selected ? skip() : null"/>
                            <button v-if="hasPermissions(['Assignment-Project-Template Write'])" class="modal__buttons__item w-auto ml-1 ml-md-2 px-3" :class="{'disabled button__disabled' : !selected}" :disabled="!selected" v-html="`Delete selected`" @click="selected ? deleteDuties() : null"/>
                            <a :href="`/assignment-projects-rooms/${parent_id}`" class="modal__buttons__item w-auto ml-1 ml-md-2 px-3">
                                Select rooms to add <img class='ml-2' width='15px' src='/assets/img/svg/add-w.svg' alt=''/>
                            </a>
                            <a v-if="hasPermissions(['Assignment-Project-Template Complete'])" :href="`/assignment-project-complete/${parent_id}`" class="modal__buttons__item w-auto ml-1 ml-md-2 px-3">
                                Complete project
                            </a>
                        </div>
                    </div>
                </div>

                <div class="row mb-0" v-if="rooms.length">
                    <div class="col-12">
                        <div class="templates__legend d-md-flex justify-content-md-between">
                            <div class="mb-2 mb-md-0 templates_legion_item" v-html="'30 days overdue'"/>
                            <div class="templates_legion_item" v-html="'60 days overdue'"/>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="table-responsive room__table">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th scope="col">
                                            <span class="custom-control custom-checkbox">
                                                <input :id="'theadcheck'" v-model="select_all" type="checkbox" class="custom-control-input" @change="selectAll()"/>
                                                <label :for="'theadcheck'" class="custom-control-label ml-2"/>
                                            </span>
                                        </th>
                                        <th scope="col" v-for="(item, i) in room_table_headers" :key="i" v-html="item.name"/>
                                    </tr>
                                </thead>

                                <draggable v-if="!isTouchDevice() && !draggable_reset" v-model="rooms" tag="tbody" :multi-drag="true" multiDragKey="SHIFT" selectedClass="sortable-selected" :avoidImplicitDeselect="true" @start="drag=true" @end="drag=false" @change="orderRequest()" ghost-class="drag-ghost" :scroll-sensitivity="1000" 
                                :force-fallback="true"
                                >
                                    <tr v-for="(item, i) in rooms" :key="i" :id="`room${i}`"
                                        class="prevent-select"
                                        :class="[item.overdue >= 30 && item.overdue < 60 ? 'background-color-yellow-overdue' : '',
                                        item.overdue >= 60  ? 'background-color-orange-overdue' : '']"
                                    >
                                        <td>
                                            <span class="custom-control custom-checkbox">
                                                <input :id="`checkAll${i}`" type="checkbox" class="custom-control-input" v-model="item.checked"/>
                                                <label :for="`checkAll${i}`" class="custom-control-label ml-2"/>
                                            </span>
                                        </td>
                                        <td>
                                            <input :id="`idinput-${item.id}`" :value="item.order" @keyup.enter="reorderByInput(item, $event.target.value)" type="number" class="order-input" required/>
                                        </td>
                                        <td> 
                                            <a href="JavaScript:void(0);" @click="viewProjectTask(i)"> {{ item.description }} </a>
                                        </td>
                                        <td v-html="item.frequency"/>
                                        <td v-html="item.room_type"/>
                                        <td v-html="item.task_name"/>
                                        <td v-html="item.last_completed_to_show"/>
                                        <td v-html="item.next_scheduled"/>
                                        <td v-html="item.daily_minutes"/>
                                    </tr>
                                </draggable>
                                <tbody v-else>
                                    <tr v-for="(item, i) in rooms" :key="i" :id="`room${i}`"
                                        :class="[item.overdue >= 30 && item.overdue < 60 ? 'background-color-yellow-overdue' : '',
                                        item.overdue >= 60  ? 'background-color-orange-overdue' : '']"
                                    >
                                        <td>
                                            <span class="custom-control custom-checkbox">
                                                <input :id="`checkAll${i}`" type="checkbox" class="custom-control-input" v-model="item.checked"/>
                                                <label :for="`checkAll${i}`" class="custom-control-label ml-2"/>
                                            </span>
                                        </td>
                                        <td>
                                            <input :disabled="check_completed_task" :id="`idinput-${item.id}`" :value="item.order" @keyup.enter="reorderByInput(item, $event.target.value)" type="number" class="order-input" required/>
                                        </td>
                                        <td> 
                                            <a href="JavaScript:void(0);" @click="viewProjectTask(i)"> {{ item.description }} </a>
                                        </td>
                                        <td v-html="item.frequency"/>
                                        <td v-html="item.room_type"/>
                                        <td v-html="item.task_name"/>
                                        <td v-html="item.last_completed_to_show"/>
                                        <td v-html="item.next_scheduled"/>
                                        <td v-html="item.daily_minutes"/>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <ProjectCompleteModal 
            :title="'Complete Project Task'"
            :rest_api="'rooms_project_complete'"
            :notyf="notyf"
            :breadcrumb="breadcrumb"
            :subtitle="subtitle"
            ref="projectCompleteModal"
        />

        <SupervisorReportModal 
            title="Confirmation Modal"
            :rest_api="rest_api"
            :breadcrumb="breadcrumb"
            @running_submit="running_submit($event)"
        />

        <SkipModal
            @objectSkip="massive_skip()"
        />

        <WaitingModal/>

    </section>
</template>

<script>

// import Breadcrumb       from  '@/components/BreadcrumbComponent/Breadcrumb.vue'
import draggable from 'vuedraggable-multi'
import FormResources        from    './form_resources'
import Resources            from    './resources'
import DetailComponent      from    '@/components/DetailComponent/DetailComponent'
import ProjectCompleteModal from    '@/components/BuildingComponent/Rooms/ProjectCompleteModal'
import SkipModal            from    './SkipModal'
import WaitingModal         from    '@/components/WaitingModal'
import { Notyf }            from    'notyf';
import 'vuetify/dist/vuetify.min.css'
import 'notyf/notyf.min.css'; // for React and Vue
import SupervisorReportModal from './SupervisorReportModal.vue'
const notyf = new Notyf({
    duration: 8000,
});

export default {
    name: 'ProjectTemplateDetail',

    components: {
    // Breadcrumb,
    DetailComponent,
    SkipModal,
    WaitingModal,
    SupervisorReportModal,
    ProjectCompleteModal,
    draggable
},
    
    data(){
        return{
            notyf,
            user:                  this.get_user(),
            parent_id:             this.$route.params.id,
            rest_api:              `projects/${this.$route.params.id}`,
            lite_rest_api:         `projects`,
            own_rest_api:          `projects-rooms`,
            rest_api_note:         `project_notes`,
            form_format:           FormResources.form_format,
            breadcrumb:            Resources.breadcrumb,
            check_completed_task:  false,
            title_page:            '',
            content_header:        this.$store.state.headers,
            single_object:         {},
            array_options:         {},
            rooms:                 [],
            room_table_headers:    Resources.room_table_headers,
            select_all:            false,
            skip_rooms:            [],
            current_date:          this.currentDateToString(),
            subtitle:   '',
            format: '',
            draggable_reset: false,
            rooms_backup: []
        }
    },

    methods:{

        async deleteDuties()
        {
            let duties = this.rooms.filter(item => item.checked)

            if(!duties.length)
            {
                return false
            }

            let confirmation = confirm('Are you sure to proceed with the selected action?')

            if(confirmation)
            {
                this.loader(true)

                let project_schedulers_id = duties.map(item => item.id)

                let route = `${this.own_rest_api}/massive_detach/${this.parent_id}`

                let response = await this.patch(route, project_schedulers_id)

                this.loader()

                if(response.status)
                {
                    duties.forEach((item) => {
                        let index = this.rooms.findIndex(prop => prop.id === item.id)
                        if(index > -1)
                        {
                            console.log(Number(this.single_object.minutes) + ' oo ' + Number(item.actual_minutes))
                            this.single_object.minutes = this.stringToNumber(this.single_object.minutes) - this.stringToNumber(item.daily_minutes)
                            this.single_object.minutes = this.numberStringFormat(this.single_object.minutes)
                            this.rooms.splice(index, 1)
                        }
                    })

                    notyf.success('Success')
                }
                else
                {
                    this.error_handling(response)
                }
            }
        },

        fill_data(data)
        {
            this.single_object = data.project
            
            this.rooms = data.rooms

            this.rooms.forEach((item, index) => {
                item['checked'] = false
                item['order'] = index + 1 
            })

            this.rooms_backup = JSON.parse(JSON.stringify(this.rooms))

            this.title_page = this.single_object.description

            this.breadcrumb[2].arrow = "<span class='slash'>/</span>"

            this.breadcrumb.push({
                name: this.single_object.description,
                href: `/assignment-projects/${this.parent_id}`,
                arrow: "",
            })
            
            this.array_options = {
                associate_id: data.associates,
                show_minutes: Resources.standard_options,
            }
        },

        selectAll()
        {
            if(this.rooms.length)
            {
                this.rooms.map(item => {
                    item.checked = this.select_all
                })
            }
        },

        async viewProjectTask(index)
        {
            const room = this.rooms[index]
            this.subtitle =  `${room.description} - ${room.task_name}`
            this.$refs.projectCompleteModal.getInitialData(room, 'room_task_id')
            window.$('#static-project-complete').modal('show')

        },

        skip()
        {
            this.skip_rooms = this.rooms.filter(item => item.checked && item.overdue >= 30).map(item => ({
                id: item.project_work_page_id,
                frequency_number_day: item.frequency_number_day
            }))
            
            if(!this.skip_rooms.length)
            {
                this.notyf.error('You must select at least one of room and only overdue');
                return false
            }

            window.$('#static-update-skip').modal('show')
        },

        async massive_skip()
        {
            const http_request = {
                ids: this.skip_rooms,
                massive_skip: true,
            }

            this.loader(true)

            const response = await this.patch(`${this.lite_rest_api}/${JSON.stringify(http_request)}`, this.form_data)

            this.loader()

            if(response.status)
            {
                this.notyf.success('Success!')

                response.data.jumpers.forEach( item =>
                {
                    const index = this.rooms.findIndex(value => value.project_work_page_id == item.id)

                    if(index > -1)
                    {
                        this.rooms[index].overdue = 0
                        this.rooms[index].last_completed = item.last_completed
                        this.rooms[index].next_scheduled = item.next_scheduled
                    }
                })

                this.skip_rooms = []
                this.select_all = false
                this.selectAll()
            }
            else
            {
                this.error_handling(response)
            }
        },

        async running_submit(report_version)
        {

            if(this.format === 'xlsx' || this.format === 'csv')
            {
                const form_data = {
                id: this.single_object.decrypted_id,
                standard_report_id: 7,
                headers: (report_version.supervisor_report) ? Resources.rooms_report_table_headers : Resources.rooms_report_table_headers_employee,
                totals: Resources.rooms_report_totals,
                format: this.format,
                }

                this.loader(true)

                const response = await this.post('search_standard_reports', form_data)

                if(response.status)
                {
                    this.downloadFile(response)
                }
                else
                {
                    this.error_handling(response)
                }

                this.loader()
            }
            else
            {
                let url = `/standard-reports/projects/project-assignment?id=${this.single_object.decrypted_id}&supervisor_copy=${report_version.supervisor_report}&format=${this.format}`

                window.open(url, '_blank');
            }


            // console.log(report_version.supervisor_report)
            // const form_data = {
            //     id: this.single_object.id,
            //     standard_report_id: 7,
            //     headers: (report_version.supervisor_report) ? Resources.rooms_report_table_headers : Resources.rooms_report_table_headers_employee,
            //     totals: Resources.rooms_report_totals,
            //     format: this.format,
            // }

            // this.loader(true)

            // const response = await this.post('search_standard_reports', form_data)

            // if(response.status)
            // {
            //     this.downloadFile(response)
            // }
            // else
            // {
            //     this.error_handling(response)
            // }

            // this.loader()
        },

        async confirmationReportModal(format)
        {
            this.format = format

            window.$('#static-supervisor-modal').modal('show')

        },

        reorderByInput(item, new_order) 
        {
            if(new_order === '') {
                this.notyfMesg('Please enter a valid number', 'error')
                return
            }
            if(item.order > Number(new_order))
            {
                item.order = Number(new_order) - 1
            }
            else
            {
                item.order = Number(new_order) + 1
            }
            
            this.rooms.sort((a, b) => a.order - b.order);

            this.orderRequest(false)
        },

        async orderRequest(show_loader = true)
        {
            let rooms_id = []
            let backup_rooms = []

            if(show_loader)
            {
                this.loader(true)
            }

            let rooms_assigned = JSON.parse(JSON.stringify(this.rooms))
            rooms_assigned.forEach( (item, index) => {rooms_id.push(item.id); backup_rooms.push({...item, order: index + 1 })} )


            this.draggable_reset = true
            let response  = await this.post(`order_project_schedulers`, rooms_id)

            if(response.status)
            {
                this.rooms = backup_rooms
                this.rooms_backup = JSON.parse(JSON.stringify(this.rooms))
                this.loader()
                this.draggable_reset = false
            }
            else
            {
                this.error_handling(response)
                
                this.loader()
            }
        },
    },

    async mounted()
    {
        if(this.hasPermissions(['Assignment-Project-Template Read']))
        {
            await this.api_request(this.rest_api)
        }
        else
        {
            window.location = '/'
        }
    },

    watch: {
        check_completed_task(val)
        {
            this.draggable_reset = val

            this.rooms =  val ? this.rooms_backup.filter( item => item.last_completed !== '' && item.next_scheduled !== '' ? this.current_date > item.last_completed && this.current_date < item.next_scheduled : item ) : this.rooms_backup
        }
    },

    computed:
    {
        selected()
        {
            let bool = this.rooms.filter(item => item.checked)
            return Boolean(bool.length)
        }
    }
}

</script>

<style scoped>

    .drag-ghost {
        border-bottom: 3px solid #008AD8;
    }

</style>